import React from 'react';
import PropTypes from 'prop-types';
import CallupHead from './callupHead';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        keyword: PropTypes.array,
        wxLaunch: PropTypes.object,
    };
    render() {
        const { content, keyword, wxLaunch } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7262673576889719808',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9171',
              };
        let callAppType = content.type === 'article' ? 'doc' : content.type;

        callAppType = callAppType === 'slide' ? 'immersionslide' : callAppType;
        const headData = {
            isVideoShare: content.isVideoShare,
            pageInfo: {
                type: callAppType,
                url: typeof window === 'object' ? location.href : '',
                id: content.base62Id,
                downloads,
                noKindFrom: 1,
            },
            topClickInfo: {
                callupKind: 'inter|in_sf02',
                actionName: 'wap_topopen'
            },
            fixClickInfo: {
                callupKind: 'inter|in_sf02',
                actionName: 'wap_topopen'
            },
            hotKeyword: keyword,
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        };

        return (
            <div onClick={this.clickHandle}>
                <CallupHead content={headData} isSendCount />
            </div>
        );
    }
}

export default errorBoundary(Header);
